import MaintenancePage from '@/pages/manufacturing/maintenance/page';

export default function MaintenanceCalendarWrapper() {
  return <MaintenancePage initialTab="calendar" />;
}